// src/components/LandingPage.js - Minimal Changes
import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import RegistrationForm from './RegistrationForm';
import './LandingPage.css';

const LandingPage = () => {
    const [activeTab, setActiveTab] = useState('login'); // Default to register

    // Prevent body scroll when landing page is active
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
            document.documentElement.style.overflow = 'auto';
        };
    }, []);

    return (
        <div className="landing-page">
            {/* Simple Elegant Logo Bar - NO BUTTONS */}
            <div className="logo-bar-elegant">
                <div className="logo-elegant">
                    <span className="logo-icon-elegant">🛡️</span>
                    <div className="logo-text-elegant">
                        <span className="logo-main">Smart AI Analyzer</span>
                        <span className="logo-sub">Enterprise Intelligence</span>
                    </div>
                </div>
            </div>

            {/* Main Content - Two Column Layout (Your original layout) */}
            <div className="landing-main-no-scroll">
                {/* Left Column - Marketing Content */}
                <div className="marketing-column">
                    <div className="badge-wrapper">
                        <span className="live-badge">
                            <span className="pulse-dot"></span>
                            AI-Powered Platform
                        </span>
                    </div>

                    <h1 className="main-headline">
                        Reduce Incident Investigation Time by{' '}
                        <span className="highlight-gradient">70%</span>
                    </h1>

                    <p className="subheadline">
                        From 2 hours to 10 minutes — get instant root cause analysis,
                        timeline reconstruction, and actionable resolution steps.
                    </p>

                    {/* Key Metrics */}
                    <div className="metrics-row">
                        <div className="metric">
                            <div className="metric-value">70%</div>
                            <div className="metric-label">Faster MTTR</div>
                        </div>
                        <div className="metric-divider"></div>
                        <div className="metric">
                            <div className="metric-value">2h → 10m</div>
                            <div className="metric-label">Avg Investigation</div>
                        </div>
                        <div className="metric-divider"></div>
                        <div className="metric">
                            <div className="metric-value">99.9%</div>
                            <div className="metric-label">Accuracy Rate</div>
                        </div>
                    </div>

                    {/* Enterprise Features */}
                    <div className="features-list">
                        <div className="feature-item">
                            <span className="feature-check">✓</span>
                            <span>Multi-LLM Powered Analysis</span>
                        </div>
                        <div className="feature-item">
                            <span className="feature-check">✓</span>
                            <span>Enterprise Security (SOC2, GDPR)</span>
                        </div>
                        <div className="feature-item">
                            <span className="feature-check">✓</span>
                            <span>Self-Host Option Available</span>
                        </div>
                        <div className="feature-item">
                            <span className="feature-check">✓</span>
                            <span>24/7 AI Incident Response</span>
                        </div>
                    </div>

                    {/* Trust Section */}
                    <div className="trust-section">
                        <p className="trust-text">Trusted by global enterprises</p>
                        <div className="company-logos">
                            <span className="logo-placeholder">TechCorp</span>
                            <span className="logo-placeholder">GlobalBank</span>
                            <span className="logo-placeholder">CloudScale</span>
                            <span className="logo-placeholder">SecureNet</span>
                        </div>
                    </div>
                </div>

                {/* Right Column - Auth Card */}
                <div className="auth-column">
                    <div className="auth-card-modern">
                        <div className="auth-header">
                            <h2>{activeTab === 'login' ? 'Welcome Back' : 'Create Account'}</h2>
                            <p>
                                {activeTab === 'login'
                                    ? 'Sign in to access your incident workspace'
                                    : 'Start your 14-day free trial — no credit card required'}
                            </p>
                        </div>

                        <div className="auth-tabs-enhanced">
                            <button
                                className={`tab-enhanced ${activeTab === 'login' ? 'active' : ''}`}
                                onClick={() => setActiveTab('login')}
                            >
                                Sign In
                            </button>
                            <button
                                className={`tab-enhanced ${activeTab === 'register' ? 'active' : ''}`}
                                onClick={() => setActiveTab('register')}
                            >
                                Create Account
                            </button>
                        </div>

                        <div className="auth-body">
                            {activeTab === 'login' ? <LoginForm /> : <RegistrationForm />}
                        </div>

                        <div className="auth-footer-note">
                            <div className="security-icons">
                                <span>🔐 SOC2 Type II</span>
                                <span>🛡️ ISO 27001</span>
                                <span>🌍 GDPR Compliant</span>
                            </div>
                            <p>Secure authentication powered by Microsoft Entra ID</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;